/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Directory_Taxonomy_Detail_Products_TitleInputs */

const en_directory_taxonomy_detail_products_title = /** @type {(inputs: Directory_Taxonomy_Detail_Products_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Products for ${i?.name}`)
};

const zh_directory_taxonomy_detail_products_title = /** @type {(inputs: Directory_Taxonomy_Detail_Products_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}相关产品`)
};

/**
* | output |
* | --- |
* | "Products for {name}" |
*
* @param {Directory_Taxonomy_Detail_Products_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_taxonomy_detail_products_title = /** @type {((inputs: Directory_Taxonomy_Detail_Products_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Taxonomy_Detail_Products_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_taxonomy_detail_products_title(inputs)
	return zh_directory_taxonomy_detail_products_title(inputs)
});
export { directory_taxonomy_detail_products_title as "directory.taxonomy_detail.products_title" }